import { render, staticRenderFns } from "./XhDateTime.vue?vue&type=template&id=36a21c36&scoped=true"
import script from "./XhDateTime.vue?vue&type=script&lang=js"
export * from "./XhDateTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a21c36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36a21c36')) {
      api.createRecord('36a21c36', component.options)
    } else {
      api.reload('36a21c36', component.options)
    }
    module.hot.accept("./XhDateTime.vue?vue&type=template&id=36a21c36&scoped=true", function () {
      api.rerender('36a21c36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCom/XhDateTime.vue"
export default component.exports